import apiClient from '../utils/axios-config';
import { BlogComment } from '../types/blog';
import { logger } from '../utils/logger';

class CommentService {
  async listComments(articleId: string): Promise<BlogComment[]> {
    try {
      const response = await apiClient.get(`/blog/${articleId}/comments`);
      return response.data.comments || response.data || [];
    } catch (error) {
      logger.apiError('listing comments', error);
      throw error;
    }
  }

  async createComment(articleId: string, data: {
    body: string;
    parentCommentId?: string | null;
  }): Promise<BlogComment> {
    try {
      const response = await apiClient.post(`/blog/${articleId}/comments`, data);
      return response.data.comment || response.data;
    } catch (error) {
      logger.apiError('creating comment', error);
      throw error;
    }
  }

  async flagComment(commentId: string): Promise<void> {
    try {
      await apiClient.post(`/comments/${commentId}/flag`);
    } catch (error) {
      logger.apiError('flagging comment', error);
      throw error;
    }
  }

  async deleteComment(commentId: string): Promise<void> {
    try {
      await apiClient.delete(`/comments/${commentId}`);
    } catch (error) {
      logger.apiError('deleting comment', error);
      throw error;
    }
  }
}

export default new CommentService();
